var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_122779",
    "data-name": "Group 122779",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#1b4a83"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-supervisor-account",
    "data-name": "Icon material-supervisor-account",
    d: "M14.085,12.851a1.911,1.911,0,1,0-1.911-1.911A1.905,1.905,0,0,0,14.085,12.851Zm-5.733-.764A2.293,2.293,0,1,0,6.058,9.793,2.284,2.284,0,0,0,8.351,12.087Zm5.733,2.293c-1.4,0-4.2.7-4.2,2.1V18.2h8.409v-1.72C18.289,15.083,15.484,14.38,14.085,14.38Zm-5.733-.764C6.57,13.616,3,14.51,3,16.291V18.2H8.351v-1.72a3.013,3.013,0,0,1,1.812-2.653A9.39,9.39,0,0,0,8.351,13.616Z",
    transform: "translate(3.356 1.149)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customerIcon.57e9687d360b3257fe93a2daa3462c2c.svg";
export { ForwardRef as ReactComponent };